export default __webpack_public_path__ + "static/media/vite.d093fea5.svg";